export default __webpack_public_path__ + "static/media/doctor-subscribe.f5ffbf2e.png";